import React from 'react';
import PropTypes from 'prop-types';
import * as items from '../Items';
import Collapse from '../../Global/Collapse/Collapse';
import Button from '../../Global/Buttons/Button';
import Icon from '../../Global/Icons/Icon';
import ItemColorSelect from '../ItemColorSelect';

const DiagramCreatorLines = ({ activeTool, toggleLine, activeColor, changeColor }) => (
  <Collapse
    show
    trigger={
      <div>
        Arrows + Lines <span className="text-grey">(click + drag)</span>
        <Icon name="arrow-down" size="m" fill="black" />
      </div>
    }
    content={
      <div className="sidebar-dropdown">
        <ItemColorSelect activeColor={activeColor} changeColor={changeColor} />

        <ul className="col-2">
          <li className={activeTool === 'line_with_arrow' && 'active-tool'} style={{ fill: activeColor }}>
            <Button classes="tool-btn line-with-arrow" onClick={e => toggleLine(e, items.LEGACY_LINE_WITH_ARROW)}>
              <Icon name="line-with-arrow" />
            </Button>
          </li>

          <li className={activeTool === 'dashed_line_with_arrow' && 'active-tool'} style={{ fill: activeColor }}>
            <Button classes="tool-btn dashed-line-with-arrow" onClick={e => toggleLine(e, items.LEGACY_DASHED_LINE_WITH_ARROW)}>
              <Icon name="dashed-line-with-arrow" />
            </Button>
          </li>

          <li className={activeTool === 'wavy_line_with_arrow' && 'active-tool'} style={{ fill: activeColor }}>
            <Button classes="tool-btn wavy-line-with-arrow" onClick={e => toggleLine(e, items.WAVY_LINE_WITH_ARROW)}>
              <Icon name="wavy-line-with-arrow" />
            </Button>
          </li>

          <li className={activeTool === 'dashed_line' && 'active-tool'} style={{ fill: activeColor }}>
            <Button classes="tool-btn dashed-line" onClick={e => toggleLine(e, items.DASHED_LINE)}>
              <Icon name="dashed-line" />
            </Button>
          </li>
        </ul>
      </div>
    }
  />
);

DiagramCreatorLines.propTypes = {
  activeTool: PropTypes.string,
  toggleLine: PropTypes.func,
  activeColor: PropTypes.string,
  changeColor: PropTypes.func,
};

export default DiagramCreatorLines;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Tools/DiagramCreatorLines.js